export enum PageState {
  Default = 'default',
  WaitingForMeta = 'waiting-for-meta',
  WaitingForApi = 'waiting-for-api',
  CancelledByUser = 'cancelled-by-user',
  Error = 'error',
  Done = 'done',
}
